import { render, staticRenderFns } from "./face-templete-detail.vue?vue&type=template&id=f8bf9aec&scoped=true"
import script from "./face-templete-detail.vue?vue&type=script&lang=ts"
export * from "./face-templete-detail.vue?vue&type=script&lang=ts"
import style0 from "./face-templete-detail.vue?vue&type=style&index=0&id=f8bf9aec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bf9aec",
  null
  
)

export default component.exports